var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "base-card",
        [
          _c("v-card-text", [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column align-center justify-center text-center py-3",
              },
              [
                _c("h2", { staticClass: "mb-5" }, [
                  _vm._v("Formulario de registro de clientes"),
                ]),
              ]
            ),
          ]),
        ],
        1
      ),
      !_vm.showValidatorModal
        ? _c(
            "v-container",
            {
              staticClass: "d-flex align-center justify-center mw-container",
              attrs: { fluid: "" },
            },
            [
              _c(
                "base-card",
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass:
                        "d-flex flex-column align-center text-center",
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "12", md: "12" } }, [
                            _c("img", {
                              staticClass: "logo",
                              attrs: {
                                src: _vm.imageLogo,
                                alt: "Logo Compañia",
                              },
                            }),
                            _c("div", { staticClass: "title" }, [
                              _c("h3", [_vm._v(_vm._s(_vm.titleForm))]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-card-text", [
                    _c("p", [
                      _vm._v("Los campos marcados con "),
                      _c("span", { staticClass: "required-asterisk" }, [
                        _vm._v("*"),
                      ]),
                      _vm._v(", son obligatorios para continuar."),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-column align-center text-center py-6",
                      },
                      [
                        _c(
                          "v-form",
                          {
                            ref: "form",
                            model: {
                              value: _vm.formValid,
                              callback: function ($$v) {
                                _vm.formValid = $$v
                              },
                              expression: "formValid",
                            },
                          },
                          [
                            _c(
                              "v-row",
                              { attrs: { dense: "" } },
                              [
                                _vm._l(
                                  _vm.visibleFormConfig,
                                  function (field, index) {
                                    return _c(
                                      "v-col",
                                      {
                                        key: field.id,
                                        attrs: {
                                          cols: "12",
                                          md: _vm.isCheckbox(field) ? 12 : 6,
                                        },
                                      },
                                      [
                                        !_vm.isCheckbox(field)
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "field-label" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "count-input",
                                                    },
                                                    [_vm._v(_vm._s(index + 1))]
                                                  ),
                                                  _vm._v(
                                                    ". " +
                                                      _vm._s(
                                                        _vm.getFieldLabel(field)
                                                      ) +
                                                      " "
                                                  ),
                                                  field.required
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "required-asterisk",
                                                        },
                                                        [_vm._v("*")]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                              _c(_vm.resolveComponent(field), {
                                                ref: field.name,
                                                refInFor: true,
                                                tag: "component",
                                                attrs: {
                                                  items: _vm.isSelect(field)
                                                    ? _vm.getSelectOptions(
                                                        field
                                                      )
                                                    : undefined,
                                                  "prepend-inner-icon":
                                                    _vm.selecIcon(field),
                                                  outlined: "",
                                                  dense: "",
                                                  disabled:
                                                    (field.name === "city" &&
                                                      !_vm.formModel
                                                        .department) ||
                                                    field.name ===
                                                      "postalCode" ||
                                                    (field.name ===
                                                      "identificationNumber" &&
                                                      !_vm.formModel
                                                        .typeOfIdentification),
                                                  type:
                                                    field.name === "dateOfBirth"
                                                      ? "date"
                                                      : "",
                                                  rules: _vm.getRules(field),
                                                  readonly:
                                                    _vm.lockValidatedFields &&
                                                    (field.name ===
                                                      "identificationNumber" ||
                                                      field.name ===
                                                        "typeOfIdentification"),
                                                },
                                                on: {
                                                  focus: function ($event) {
                                                    field.name ===
                                                      "dateOfBirth" &&
                                                      $event.target.showPicker?.()
                                                  },
                                                  keypress: function ($event) {
                                                    return _vm.handleKeypress(
                                                      $event,
                                                      field
                                                    )
                                                  },
                                                  paste: function ($event) {
                                                    return _vm.handlePaste(
                                                      $event,
                                                      field
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.formModel[field.name],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formModel,
                                                      field.name,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formModel[field.name]",
                                                },
                                              }),
                                            ]
                                          : _c("v-checkbox", {
                                              staticClass: "mt-1",
                                              attrs: {
                                                label:
                                                  field.alias ||
                                                  field.description,
                                                dense: "",
                                                rules: field.required
                                                  ? [
                                                      (v) =>
                                                        v === true ||
                                                        "Debe aceptar",
                                                    ]
                                                  : [],
                                              },
                                              model: {
                                                value:
                                                  _vm.formModel[field.name],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formModel,
                                                    field.name,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formModel[field.name]",
                                              },
                                            }),
                                      ],
                                      2
                                    )
                                  }
                                ),
                                _c(
                                  "v-alert",
                                  {
                                    staticClass: "custom-alert",
                                    attrs: {
                                      outlined: "",
                                      border: "left",
                                      closable: "",
                                    },
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "legal_text",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.legalTextHtml),
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              2
                            ),
                            _c(
                              "v-row",
                              { attrs: { justify: "center" } },
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "6" } },
                                  [
                                    _vm.showAlert
                                      ? _c(
                                          "v-alert",
                                          {
                                            staticClass: "my-4",
                                            attrs: {
                                              type: _vm.alertType,
                                              dense: "",
                                              outlined: "",
                                              border: "left",
                                              "colored-border": "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.alertMessage) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "mt-6 white--text",
                                attrs: {
                                  color: "rgb(204 33 40)",
                                  disabled: _vm.isSaveDisabled,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.save.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.isEditing
                                        ? "Actualizar Datos"
                                        : "Guardar Datos"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, opacity: "0.6", "z-index": "9999" } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64", color: "rgb(204 33 40)" },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500" },
          model: {
            value: _vm.showValidatorModal,
            callback: function ($$v) {
              _vm.showValidatorModal = $$v
            },
            expression: "showValidatorModal",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-4" },
            [
              _c(
                "v-card-title",
                {
                  staticClass:
                    "justify-center text-center font-weight-bold tam-ti",
                },
                [_vm._v(" ¿Ya eres cliente de nosotros? ")]
              ),
              _c(
                "v-card-text",
                { staticClass: "text-center" },
                [
                  _c("p", { staticClass: "mb-6" }, [
                    _vm._v("Te invitamos a que te registres"),
                  ]),
                  _c(
                    "v-form",
                    {
                      ref: "validatorFormRef",
                      model: {
                        value: _vm.isValidatorFormValid,
                        callback: function ($$v) {
                          _vm.isValidatorFormValid = $$v
                        },
                        expression: "isValidatorFormValid",
                      },
                    },
                    _vm._l(_vm.filteredVisibleFormConfig, function (field) {
                      return _c(
                        "v-col",
                        { key: field.id, attrs: { cols: "12" } },
                        [
                          field.description == "Tipo de identificación"
                            ? _c("v-select", {
                                attrs: {
                                  items:
                                    _vm.selectOptions["typeOfIdentification"],
                                  "item-text": "text",
                                  "item-value": "value",
                                  label: field.alias || field.description,
                                  "prepend-inner-icon":
                                    "mdi mdi-card-account-details-outline",
                                  outlined: "",
                                  dense: "",
                                  required: "",
                                },
                                model: {
                                  value: _vm.validatorForm.documentType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.validatorForm,
                                      "documentType",
                                      $$v
                                    )
                                  },
                                  expression: "validatorForm.documentType",
                                },
                              })
                            : _vm._e(),
                          field.description == "Número de identificación"
                            ? _c("v-text-field", {
                                ref: "valIdentification",
                                refInFor: true,
                                attrs: {
                                  label: field.alias || field.description,
                                  outlined: "",
                                  dense: "",
                                  "prepend-inner-icon":
                                    "mdi mdi-card-account-details",
                                  "error-messages": _vm.validatorError,
                                  required: "",
                                  disabled: !_vm.validatorForm.documentType,
                                  rules: _vm.getRulesModal(),
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.handleKeypressModal($event)
                                  },
                                  paste: function ($event) {
                                    return _vm.handlePasteModal($event)
                                  },
                                },
                                model: {
                                  value: _vm.validatorForm.documentNumber,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.validatorForm,
                                      "documentNumber",
                                      $$v
                                    )
                                  },
                                  expression: "validatorForm.documentNumber",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "justify-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text px-10",
                      attrs: {
                        color: "rgb(204 33 40)",
                        loading: _vm.checkingUser,
                        disabled:
                          !_vm.validatorForm.documentType ||
                          !_vm.validatorForm.documentNumber,
                      },
                      on: { click: _vm.validateClient },
                    },
                    [_vm._v(" Aceptar ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500" },
          model: {
            value: _vm.showModalResponse,
            callback: function ($$v) {
              _vm.showModalResponse = $$v
            },
            expression: "showModalResponse",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-6" },
            [
              _c("v-card-text", { staticClass: "text-center" }, [
                _c("p", { staticClass: "mb-4 font-weight-medium" }, [
                  _c("strong", [_vm._v("¡Registro exitoso!")]),
                  _vm._v(
                    " Indica tu número de identificación al cajero para facturar: "
                  ),
                ]),
                _c("div", { staticClass: "text-h5 font-weight-bold" }, [
                  _vm._v(
                    " " + _vm._s(_vm.formModel.identificationNumber) + " "
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500" },
          model: {
            value: _vm.showModalExist,
            callback: function ($$v) {
              _vm.showModalExist = $$v
            },
            expression: "showModalExist",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-6" },
            [
              _c("v-card-text", { staticClass: "text-center" }, [
                _c(
                  "p",
                  { staticClass: "mb-4 font-weight-medium" },
                  [[_vm._v(" " + _vm._s(this.messageResponse) + " ")]],
                  2
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }